export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as const;

export const YAXIS_WIDTH = 40;
export const XAXIS_MONTH_HEIGHT = 35;
export const XAXIS_YEAR_HEIGHT = 22;

export const YAXIS_TICK = { fontSize: 11 } as const;
export const MONTH_TICK = { fontSize: 12 } as const;
export const YEAR_TICK = { fontSize: 12, fontWeight: 600 } as const;
